import React, {Component} from 'react';
import strings from 'strings';
import nosound from 'assets/nosound.mp3';
import {unlockAudio} from 'utils/playSound';

import './styles.scss';

class AdminReadyButton extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	handleClick = (event) => {
		unlockAudio(nosound);
		if (this.props.onClick) this.props.onClick(event);
	};

	render() {
		const {remoteIsReady, isPractiseTasks, isPractiseTask} = this.props;

		const buttonText = isPractiseTasks
			? strings.startPracticeTasks
			: isPractiseTask
			? strings.startPracticeTask
			: strings.starttest;

		return (
			<div className="AdminReadyButton">
				<button
					className="AdminReadyButton__button"
					disabled={!remoteIsReady}
					onClick={this.handleClick}
				>
					{buttonText}
				</button>{' '}
				<p className="AdminReadyButton__label">
					{!remoteIsReady && strings.waitingForCandidate}
				</p>
			</div>
		);
	}
}

export default AdminReadyButton;
